export const quote_signature_url: string = "quote_signature";
export const order_signature_url: string = "order_signature";
export const shop_quote_signature_url: string = "shop_quote_signature";
export const self_order_signature_url: string = "self_order_signature";
